import { render, staticRenderFns } from "./SanityLink.vue?vue&type=template&id=822ef46e"
import script from "./SanityLink.vue?vue&type=script&lang=js"
export * from "./SanityLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports